import { HeadCell } from '../../../../constants/dashboard';

export const TABLE_HEAD_LIST: readonly HeadCell[] = [
  { id: 'email', label: 'Email' },
  { id: 'first_name', label: 'First name' },
  { id: 'last_name', label: 'Last name' },
  { id: 'role', label: 'Role' },
  { id: 'buttons', label: '' }
] as const;
